import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';

export const TurboNode = memo(({ data, selected }) => {
  const activityClass = data.activity ? `node-${data.activity}` : '';
  const errorClass = data.hasError ? 'node-error' : '';
  const accent = data.color || 'var(--accent-primary)';

  return (
    <div
      className={`turbo-node-wrapper ${activityClass} ${errorClass}`}
      style={{ '--node-accent': accent }}
    >
      <div
        className={`turbo-node ${selected ? 'selected' : ''}`}
        data-testid={`node-${data.type || 'default'}`}
      >
        {data.hasInput !== false && (
          <Handle
            type="target"
            position={Position.Left}
            className="turbo-handle target"
          />
        )}

        <div className="turbo-node-accent" aria-hidden />
        <div className="turbo-node-content">
          <div className="turbo-node-icon-wrap">
            <div className="turbo-node-icon">{data.icon}</div>
          </div>
          <div className="turbo-node-body">
            <div className="turbo-node-title">{data.title || data.label}</div>
            {data.subtitle && (
              <div className="turbo-node-subtitle">{data.subtitle}</div>
            )}
          </div>
        </div>

        {/* Activity indicator */}
        {data.activity && (
          <div className={`node-activity-indicator ${data.activity}`} />
        )}

        {/* Output Handle */}
        {data.hasOutput !== false && (
          <Handle
            type="source"
            position={Position.Right}
            className="turbo-handle source"
          />
        )}
      </div>
    </div>
  );
});

TurboNode.displayName = 'TurboNode';
